import axios from 'axios';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';

const POSITIVE_DECISION = 'YES';
const NEGATIVE_DECISION = 'NO';

export const initAuthPrompt = (display) => ({
  type: types.INIT_AUTH_CALL,
  payload: display,
});

const confirmCall = () => ({ type: types.CONFIRM_AUTH_CALL });

const rejectConfirm = () => ({ type: types.REJECT_AUTH_CALL });

const sendingAuthPrompt = () => ({ type: types.SENDING_CONFIRM });

const authFailed = () => ({ type: types.AUTH_FAILED });

const sendConfirmation = (decision) => (dispatch) => {
  dispatch(sendingAuthPrompt());

  return axios.post('/smarthelp/validate-confirm-login', {
    _csrf: Page.getCSRFtoken(),
    decision,
    docId: Page.getStepupUUID(),
  })
    .then(() => {
      if (decision === POSITIVE_DECISION) {
        dispatch(confirmCall());
      } else if (decision === NEGATIVE_DECISION) {
        dispatch(rejectConfirm());
      }
    })
    .catch(() => {
      // Update error case
      dispatch(authFailed());
    });
};

// Users clicked 'Yes' button in the Auth prompt module
export const authPositiveConfirm = () => (dispatch) => {
  // dispatch(confirmCall());
  dispatch(sendConfirmation(POSITIVE_DECISION));
};

// Users clicked 'No' button in the Auth prompt module
export const authNegativeConfirm = () => (dispatch) => {
  // dispatch(rejectConfirm());
  dispatch(sendConfirmation(NEGATIVE_DECISION));
};

export const closeWindow = () => ({ type: types.CLOSE_AUTH_CALL });
